import React from "react";
import { Icon, PlainButton } from "@culturehq/components";
import { Trans } from "app/utils";

interface AnimationBackButtonProps {
  onBack: () => void;
}

const AnimationBackButton = ({ onBack }: AnimationBackButtonProps) => (
  <div className="MediaMenuHeader">
    <PlainButton onClick={onBack}>
      <Icon icon="chevron-left" />
    </PlainButton>
    <h2><Trans>Animations</Trans></h2>
  </div>
);

export default AnimationBackButton;
